import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bordered-card bordered-card_secondary" }
const _hoisted_2 = { class: "small striped toggle no-underline" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("thead", { class: "large large_padding" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, " NBF Participant ID "),
    /*#__PURE__*/_createElementVNode("th", null, " First Name "),
    /*#__PURE__*/_createElementVNode("th", null, " Last Name "),
    /*#__PURE__*/_createElementVNode("th", null, " Suffix "),
    /*#__PURE__*/_createElementVNode("th", null, " Birth Date "),
    /*#__PURE__*/_createElementVNode("th", null, " Email "),
    /*#__PURE__*/_createElementVNode("th", null, " Last Login "),
    /*#__PURE__*/_createElementVNode("th", null, " Actions ")
  ])
], -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "col-md-1 hide-desktop" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "col-md-1" }
const _hoisted_9 = { class: "col-md-1" }
const _hoisted_10 = { class: "col-md-1" }
const _hoisted_11 = { class: "col-md-1" }
const _hoisted_12 = { class: "col-md-2" }
const _hoisted_13 = { class: "col-md-1" }
const _hoisted_14 = { class: "col-md-1 hide-mobile" }
const _hoisted_15 = {
  class: "tooltip-wrapper",
  "data-tooltip": "Masquerade"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("tr", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "8" }, " No Participants found")
], -1)
const _hoisted_19 = [
  _hoisted_18
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertsComponent = _resolveComponent("AlertsComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AlertsComponent, { error: _ctx.error }, null, 8, ["error"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("table", _hoisted_2, [
        _hoisted_3,
        (_ctx.persons.length)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.persons, (person) => {
                return (_openBlock(), _createElementBlock("tr", {
                  class: "large",
                  key: person.PersonID
                }, [
                  _createElementVNode("td", {
                    class: "col-md-2 cell-primary plan-modal",
                    onClick: ($event: any) => (_ctx.openModal('edit-user', 'Participants', 'plan-profile plan-tables plan-profile', null, { UserID: person.UserID }))
                  }, _toDisplayString(person.PersonID), 9, _hoisted_5),
                  _createElementVNode("td", _hoisted_6, [
                    _createElementVNode("i", {
                      class: "plan-modal iatse-icon-Vector-8 fs-xxs",
                      onClick: ($event: any) => (_ctx.loginAsUser(person.UserID))
                    }, null, 8, _hoisted_7)
                  ]),
                  _createElementVNode("td", _hoisted_8, _toDisplayString(person.FirstName), 1),
                  _createElementVNode("td", _hoisted_9, _toDisplayString(person.LastName), 1),
                  _createElementVNode("td", _hoisted_10, _toDisplayString(person.Suffix), 1),
                  _createElementVNode("td", _hoisted_11, _toDisplayString(person.BirthDate), 1),
                  _createElementVNode("td", _hoisted_12, _toDisplayString(person.Email), 1),
                  _createElementVNode("td", _hoisted_13, _toDisplayString(person.LastLogin), 1),
                  _createElementVNode("td", _hoisted_14, [
                    _createElementVNode("span", _hoisted_15, [
                      _createElementVNode("i", {
                        class: "plan-modal iatse-icon-Vector-8 fs-xxs",
                        onClick: ($event: any) => (_ctx.loginAsUser(person.UserID))
                      }, null, 8, _hoisted_16)
                    ])
                  ])
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("tbody", _hoisted_17, _hoisted_19))
      ])
    ])
  ], 64))
}